module.exports = __webpack_public_path__ + "img/mbh1.92dc1777.jpg";